import { PropsWithChildren } from 'react';

export default function Content({ children }: PropsWithChildren) {
	return <div className="items-start mb-10">{children}</div>;
}
